import permissions from "@/router/userPermissions";
import crudUpdateMd from "@/components/crud-md/actions/Edit";

export default [
  {
    path: "devices",
    name: "devices",
    component: () => import("@/modules/cardioguard-admin/views/DevicesCrud"),
    meta: { auth: permissions.scopes.admin, serviceName: "devices", title: "Equipos" },
  },
  {
    path: "devices/:id",
    name: "devicesEdit",
    component: crudUpdateMd,
    meta: {
      auth: permissions.scopes.admin,
      parentPathNames: ["devices"],
      serviceName: "devices",
      title: "Equipos",
    },
  },
];
